import { IOrganizationRelationListingModel, OrganizationRelationListingModel } from '@common/models/OrganizationRelationListingModel';
import { action, computed, makeObservable, observable } from 'mobx';
import { UserStore } from './UserStore';

export class UserLocationsConfirmDeleteStore {
    userStore!: UserStore;
    @observable visible: boolean = false;
    @observable organization: OrganizationRelationListingModel | undefined;
    
    constructor(userStore: UserStore) {
        this.userStore = userStore;
        makeObservable(this, undefined, { autoBind: true });
    }

    @computed get description() {
        return `Are you sure you want to remove access to ${this.organization?.organizationName} for this user?`;
    }
    
    @action.bound show(organization: IOrganizationRelationListingModel) {
        this.organization = organization;
        this.visible = true;
    }
    
    @action.bound close() {
        this.visible = false;
    }
    
    @action.bound async confirm() {
        await this.userStore.deleteOrganization(this.organization!);
        this.visible = false;
    }
}
